import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/shadcn-utils';

const buttonVariants = cva(
  'inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime-300/40 disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        default: 'bg-[#2EFF0C] text-zinc-950 hover:bg-[#2EFF0C] border-none',
        destructive: 'bg-rose-600 text-white hover:bg-rose-500 border-none',
        outline: 'border border-emerald-700/70 bg-transparent text-emerald-50 hover:bg-emerald-900/40 border-none',
        secondary: 'bg-emerald-900/70 text-emerald-50 hover:bg-emerald-800/70 border-none',
        ghost: 'text-emerald-100 hover:bg-emerald-900/40 border-none',
        link: 'text-lime-300 underline-offset-4 hover:underline border-none'
      },
      size: {
        default: 'h-10 px-4 py-2',
        sm: 'h-9 rounded-md px-3',
        lg: 'h-11 rounded-md px-8',
        icon: 'h-10 w-10'
      }
    },
    defaultVariants: {
      variant: 'default',
      size: 'default'
    }
  }
);

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : 'button';
  return <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />;
});
Button.displayName = 'Button';

export { Button, buttonVariants };

